

import React, { useState } from "react";
import axios from "axios";
import '../../CSS/Global.css'; // 🔁 Link your CSS here
import { toast } from "react-toastify";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { UploadCloudIcon, X } from "lucide-react";
const getFileIcon = (url) => {
    const urlmain = process.env.REACT_APP_LINK
    const ext = url.split('.').pop().toLowerCase();

    if (["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg"].includes(ext)) {
        return `${urlmain}${url}`; // return actual image
    }

    if (["xlsx", "xls", "csv"].includes(ext)) return "/icons/excel.png";
    if (["pdf"].includes(ext)) return "/icons/pdf.webp";
    if (["doc", "docx"].includes(ext)) return "/icons/word.png";
    if (["ppt", "pptx"].includes(ext)) return "/icons/ppt.png";
    if (["mp4", "mov", "avi", "mkv"].includes(ext)) return "/icons/video.png";
    if (["mp3", "wav", "aac", "flac", "m4a"].includes(ext)) return "/icons/audio.png";
    if (["zip", "rar"].includes(ext)) return "/icons/zip.png";
    if (["txt", "cls"].includes(ext)) return "/icons/text.png";

    return "/icons/file.png"; // default file icon
};

function ImageModalDownloadable({ show, handleClose, images, onImageSelect, multiple, setImages }) {
    const [selectedImages, setSelectedImages] = useState([]);
    const [activeTab, setActiveTab] = useState("media");
    const [isDragging, setIsDragging] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const user = getDecryptedUserFromCookie();
    const url = process.env.REACT_APP_LINK

    if (user) {
        console.log("✅ User:", user);
    } else {
        console.log("⚠️ User not found or decryption failed.");
    }
    // const handleImageClick = (image) => {
    //     setSelectedImages([image]);
    // };

    const handleImageClick = (image) => {
        const ext = (image?.url || "").split('.').pop().toLowerCase();
        const disallowedExtensions = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'svg'];

        if (disallowedExtensions.includes(ext)) {
            toast.warning("Images are not allowed in this section.");
            return;
        }

        setSelectedImages([image]);
    };

    const handleConfirm = () => {
        onImageSelect(multiple ? selectedImages : selectedImages[0]);
        handleClose();
    };

    // const handleFileInputChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) handleImageUpload(file);
    // };

    const handleFileInputChange = (e) => {
        const file = e.target.files[0];
        if (file && file.size > 32 * 1024 * 1024) {
            alert("File size exceeds 32MB.");
            return;
        }
        if (file) handleImageUpload(file);
    };

    const handleImageUpload = async (file) => {
        const formData = new FormData();
        formData.append("image", file);
        formData.append("user_id", user.main_id)
        formData.append("user_name", user.full_name)

        setUploading(true);
        setUploadProgress(0);
        try {
            const res = await axios.post(`${url}/api/images/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (event) => {
                    const percent = Math.round((event.loaded * 100) / event.total);
                    setUploadProgress(percent);
                }
            });
            if (res.status === 201) {
                const all = await axios.get(`${url}/api/images/${user.main_id}`);
                setImages((all.data).reverse());
                setUploadSuccess(true);
            }

        } catch (err) {
            console.error("Upload failed", err);
        } finally {
            setUploading(false);
            setTimeout(() => setUploadSuccess(false), 3000);
        }
    };

    const handleImageDelete = async (id) => {
        try {
            await axios.delete(`${url}/api/images/${id}`);
            const all = await axios.get(`${url}/api/images/${user.main_id}`);
            setImages((all.data).reverse());
        } catch (err) {
            console.error("Delete failed", err);
        }
    };

    if (!show) return null;

    return (
        <div className="custom-modal-overlayomsprod">
            <div className="custom-modal-contentomsprod">
                <div className="modal-headeromsprod">
                    <h3>
                        <UploadCloudIcon size={20} style={{ marginRight: '6px' }} />
                        Select or Upload File
                    </h3>
                    <X onClick={handleClose} className="close-btnomsprod" />
                </div>
                <div className="modal-tabsomsprodmain">
                    <button
                        type="button"
                        className={`images-tabs-buttons ${activeTab === 'upload' ? 'active' : ''}`}
                        onClick={() => setActiveTab('upload')}
                    >
                        Upload Files
                    </button>
                    <button
                        type="button"
                        className={`images-tabs-buttons ${activeTab === 'media' ? 'active' : ''}`}
                        onClick={() => setActiveTab('media')}
                    >
                        Media Library
                    </button>
                </div>


                <div className="modal-bodyomsprod">
                    {activeTab === 'upload' ? (
                        <div
                            className={`upload-sectionomsprod ${isDragging ? 'drag-active' : ''}`}
                            onDragOver={(e) => {
                                e.preventDefault();
                                setIsDragging(true);
                            }}
                            onDragLeave={(e) => {
                                e.preventDefault();
                                setIsDragging(false);
                            }}
                            onDrop={(e) => {
                                e.preventDefault();
                                setIsDragging(false);
                                const file = e.dataTransfer.files[0];
                                if (!file) return;

                                const allowedExtensions = [
                                    'jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'svg',
                                    'xlsx', 'xls', 'csv', 'pdf', 'doc', 'docx', 'ppt', 'pptx',
                                    'mp4', 'mov', 'avi', 'mkv', 'mp3', 'wav', 'aac', 'flac', 'm4a',
                                    'zip', 'rar', 'txt', 'cls'
                                ];

                                const ext = file.name.split('.').pop().toLowerCase();
                                if (!allowedExtensions.includes(ext)) {
                                    toast.error("❌ Unsupported format. Please upload a valid file.");
                                    return;
                                }

                                if (file.size > 32 * 1024 * 1024) {
                                    toast.error("🚫 File size exceeds 32MB limit.");
                                    return;
                                }

                                handleImageUpload(file);
                            }}
                        >
                            <label className="file-labelomsprod">
                                <UploadCloudIcon size={18} style={{ marginRight: 6 }} />
                                Click to Select File
                                <input type="file" onChange={handleFileInputChange} hidden multiple />
                            </label>
                            <p className="upload-textomsprod">Or drag and drop files here</p>
                            <p className="upload-subtextomsprod">
                                Supported: JPG, PDF, MP4, DOCX, ZIP, etc. | Max: 32MB
                            </p>

                            {uploading && <div className="progress-baromsprod" style={{ width: `${uploadProgress}%` }} />}
                            {uploadSuccess && <div className="success-msgomsprod">✅ File uploaded successfully!</div>}
                        </div>
                    ) : (
                        <div className="media-galleryomsprod">
                            {images.map((image, idx) => (
                                <div
                                    key={idx}
                                    className={`image-wrapperomsprod ${selectedImages.includes(image) ? 'selected' : ''}`}
                                    onClick={() => handleImageClick(image)}
                                >
                                    <img src={getFileIcon(image.url)} alt="media" />
                                    {/* <button type="button" className="delete-btnomsprod" onClick={(e) => { e.stopPropagation(); handleImageDelete(image.id); }}>×</button> */}
                                    <p className="delete-btnomsprod" onClick={(e) => { e.stopPropagation(); handleImageDelete(image.id); }}><i class="fa-solid fa-trash"></i></p>
                                </div>
                            ))}
                        </div>
                    )}
                    {uploading && (
                        <div className="upload-overlay">
                            <div className="upload-box">
                                <div className="loader-circle">
                                    <div className="loader-ring"></div>
                                    <span className="loader-text">{uploadProgress}%</span>
                                </div>

                                <p>Uploading... Please wait</p>
                            </div>
                        </div>
                    )}
                </div>

                {
                    activeTab === 'upload' ? null :
                        <div className="modal-footeromsprod">
                            <button type="button" onClick={handleConfirm} className="confirm-btnomsprod">Confirm Selection</button>
                        </div>
                }

            </div>
        </div>
    );
}

export default ImageModalDownloadable;
